import React, { useState, useEffect } from 'react'
import '../App.css';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { login, validar2FAAuth } from '../actions/authActions';
import { LoaderSpinner } from '../components/LoaderSpinner';
import { Link } from 'react-router-dom';
import $ from 'jquery'
export const LoginScreen = ({ history }) => {
    const [user, setUser] = useState({
        email: '',
        password: ''
    });
    const [codigo2FA, setCodigo2FA] = useState('');
    const [remember, setRemember] = useState(false);
    const dispatch = useDispatch()

    const auth = useSelector(state => state.auth)
    const { isAuthenticated: isAuth, loading, user: authUser } = auth;
    const search_custom_page = useSelector(state => state.landings.search_custom_page)


    useEffect(() => {
        if (isAuth && !authUser?.require2FA) {
            history.push('/home');
        }
        let access = localStorage.getItem('app_marketing_access')
        if (access) {
            access = JSON.parse(access);
            if (access.email && access.password) {
                setUser({
                    email: access.email,
                    password: access.password
                })
            }
        }
        // console.log('search_custom_page',search_custom_page)
        if (search_custom_page == null) {
            $('#loading').hide();
        }

    }, [isAuth, search_custom_page, authUser, history])

    const handleSubmit = (e) => {
        e.preventDefault();

        if (authUser?.require2FA) {
            dispatch(validar2FAAuth(authUser.userId, codigo2FA));
        } else {
            if (remember) {
                localStorage.setItem('app_marketing_access', JSON.stringify({ email: user.email, password: user.password }));
            }
            dispatch(login(user.email, user.password))
        }
    }

    const handleChange = (e) => {
        if (e.target.name == 'email') {
            setUser({
                ...user,
                [e.target.name]: e.target.value.trim()
            })
        } else {

            setUser({
                ...user,
                [e.target.name]: e.target.value
            })
        }
    }

    const handle2FAChange = (e) => {
        setCodigo2FA(e.target.value);
    }

    return (

        <div id="loginWrapper">
            <div id="login">


                <div className="container">
                    <div id="login-row" className="row justify-content-center align-items-center">
                        <div id="login-column" className="col-md-6">
                            <div id="login-box" className="col-md-12">
                                <div className="text-center mt-4">
                                    <img src="/Logos-impulsa-4.png" className="mt-4" />
                                </div>
                                <form id="login-form" className="form" action="" method="post" onSubmit={handleSubmit}>
                                    <h3 className="text-center colorsito">
                                        {authUser?.require2FA ? 'Verificación de Seguridad' : 'Inicio de sesión'}
                                    </h3>
                                    {
                                        loading ? <LoaderSpinner /> : null
                                    }

                                    {authUser?.require2FA ? (
                                        <div className="form-group">
                                            <p className="text-center mt-3">Ingresa el código de 6 dígitos de tu aplicación de autenticación.</p>
                                            <label htmlFor="codigo2FA" className="label-login">Código 2FA:</label><br />
                                            <input
                                                type="text"
                                                name="codigo2FA"
                                                value={codigo2FA}
                                                onChange={handle2FAChange}
                                                id="codigo2FA"
                                                className="form-control-lg form-control text-center"
                                                placeholder="000000"
                                                maxLength="6"
                                                autoFocus
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="form-group">
                                                <label htmlFor="username" className="label-login">Correo Electrónico:</label><br />
                                                <input type="text" name="email" value={user.email} onChange={handleChange} id="email" className="form-control-lg form-control" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="password" className="label-login">Contraseña:</label><br />
                                                <input type="password" name="password" value={user.password} onChange={handleChange} id="password" className="form-control-lg form-control" />
                                                <label className='mt-1' style={{ "fontSize": "13px" }}><input type="checkbox" name="remember" defaultChecked={remember} onChange={(e) => setRemember(!remember)} style={{ "width": "13px" }} /> Recordar datos de sesión</label>
                                            </div>
                                        </>
                                    )}

                                    <div className="form-group">
                                        <input type="submit" name="submit" className="btn btn-info btn-md" value={authUser?.require2FA ? "Verificar" : "Iniciar sesión"} />

                                        {!authUser?.require2FA && (
                                            <>
                                                <Link to="/register" className="label-login text-right pull-right colorsito">Registro</Link>
                                                <div style={{ "display": "block", "marginTop": "0px" }}>
                                                    <Link to="/reset_password" className="label-login text-right pull-right colorsito">Recuperar contrase&ntilde;a</Link>
                                                </div>
                                            </>
                                        )}
                                        {authUser?.require2FA && (
                                            <div className="text-center mt-3">
                                                <button type="button" className="btn btn-link colorsito" onClick={() => window.location.reload()}>
                                                    Volver al inicio de sesión
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
